import React, { PropsWithChildren } from 'react'
import { Addition } from './Addition'
import { ArrowCircle } from './ArrowCircle'
import { Brush } from './Brush'
import { Butterfly } from './Butterfly'
import { Clover } from './Clover'
import { Cog } from './Cog'
import { Digital } from './Digital'
import { DownloadArrow } from './DownloadArrow'
import { Egg } from './Egg'
import { Eyeball } from './Eyeball'
import { FilterIcon } from './FilterIcon'
import { Hand } from './Hand'
import { Illuminati } from './Illuminati'
import { LightBulb } from './LightBulb'
import { ListItemIcon } from './ListItemIcon'
import { NestedCircles } from './NestedCircles'
import { Pizza } from './Pizza'
import { PizzaNoToppings } from './PizzaNoToppings'
import { Pouch } from './Pouch'
import { Spiral } from './Spiral'
import { UpArrow } from './UpArrow'
import { UpArrowFooterCta } from './UpArrowFooterCta'
import { IconComponent } from './iconComponentType'

//Mapping of iconCode to Icon Function Component
type AtomixIconMap = Record<string, IconComponent>

export const atomixIconMap: AtomixIconMap = {
  'addition': Addition,
  'arrowcircle': ArrowCircle,
  'brush': Brush,
  'butterfly': Butterfly,
  'clover': Clover,
  'cog': Cog,
  'digital': Digital,
  'egg': Egg,
  'eyeball': Eyeball,
  'hand': Hand,
  'illuminati': Illuminati,
  'lightbulb': LightBulb,
  'nestedcircles': NestedCircles,
  'pizza': Pizza,
  'pizzanotoppings': PizzaNoToppings,
  'pouch': Pouch,
  'spiral': Spiral,
  'uparrow': UpArrow,
  'download': DownloadArrow,
  'filterIcon': FilterIcon,
  'listItemIcon': ListItemIcon,
  'upArrowFooterCta': UpArrowFooterCta,
} as const

export type IconCodeType = keyof typeof atomixIconMap

export type AtomixIconProps = React.ComponentProps<IconComponent> & {
  iconCode: IconCodeType
}

const AtomixIcon: React.FC<PropsWithChildren<AtomixIconProps>> = ({ iconCode , ...props }) => {
  const Icon = atomixIconMap[iconCode]

  // @ts-ignore
  return atomixIconMap[iconCode] !== undefined ? (<Icon { ...props } />) : null
}

export default AtomixIcon

export {
  Addition, ArrowCircle, Brush, Butterfly, Clover, Cog, Digital,
  Egg, Eyeball, FilterIcon, Hand, Illuminati, LightBulb, NestedCircles,
  Pizza, PizzaNoToppings, Pouch, Spiral, UpArrow, UpArrowFooterCta,
}

